import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { AdminApi, AdminPayoutEvent } from 'api';
import useApiCall from 'hooks/use-api-call';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';

interface DeletePayoutModalProps {
  onDeletePayout: () => void;
  onClose: () => void;
  data: AdminPayoutEvent;
}

const DeletePayoutModal: FunctionComponent<DeletePayoutModalProps> = ({ onDeletePayout, onClose, data }) => {
  const { makeAuthenticatedApi, withApi } = useApiCall();

  const api: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onSubmit = useCallback(() => {
    withApi(async () => {
      await api.adminPayoutEventsDestroy({ id: data?.id! });

      onDeletePayout();
    });
  }, [data.id]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="studioPayoutEvents.deletePayout" />
      </ModalHeader>
      <ModalContent>
        <Translate name="studioPayoutEvents.deleteConfirmation" />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.cancel" />,
              size: 'large',
              onClick: () => onClose(),
            },
            {
              name: 'delete',
              content: <Translate name="studioPayoutEvents.deletePayout" />,
              onClick: () => onSubmit(),
              variant: 'primary',
              type: 'submit',
              size: 'large',
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeletePayoutModal;
